import React from "react"
import { SignIn } from "aws-amplify-react"

// import { GoogleButton } from "./GoogleButtonSimple"


export class ArchieSignIn extends SignIn {
  constructor(props) {
    super(props)
    this._validAuthStates = ["signIn", "signedOut", "signedUp"]
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault()
    super.signIn()
  }

  showComponent() {
    return (
      <div className="auth__signin">
        {/*<GoogleButton/>
        <div className="strike">Or</div>*/}
        <form className="auth__form form" onSubmit={this.handleSubmit} method="POST">
          <div className="field">
            <label
              className="field__label"
              htmlFor="email"
            >
              Email
            </label>
            <input
              className="field__input"
              id="email"
              key="email"
              name="email"
              required
              onChange={this.handleInputChange}
              type="text"
              
            />
          </div>
          <div className="field">
            <div className="field__header">
              <label
                className="field__label"
                htmlFor="password"
              >
                Password
              </label>
              <div className="field__help">
                <a
                  className="link"
                  onClick={() => super.changeState("forgotPassword")}
                >
                  Forgot Password?
                </a>
              </div>
            </div>
            <input
              className="field__input"
              id="password"
              key="password"
              name="password"
              required
              onChange={this.handleInputChange}
              type="password"
              
            />
          </div>
          {/* <p>
            Default username is: archie@cloudbuddies.io<br/> 
            Default password is: Archie123!
          </p> */}
          <div className="form__actions">
            <button className="button button--large">
              Sign In
            </button>
          </div>
          <div className="form__help">
            Not registered yet?{" "}
            <a
              className="link"
              onClick={() => super.changeState("signUp")}
            >
              Sign up for a free account
            </a>
          </div>
        </form>
      </div>
    )
  }
}


export default ArchieSignIn
